import * as ACTION from "./SetChainIdActionType";

const setChainIdSuccess = (chainId) => {
  return {
    type: ACTION.SET_CHAIN_ID,
    payload: chainId,
  };
};

export const setChainIdAction = (chainId) => {
  return async function (dispatch) {
  dispatch(setChainIdSuccess(chainId));
  }
};
